const updates = [
  {
    time: '2小时前',
    title: '某顶流艺人深夜发文回应近期恋情传闻，工作室同步发布声明',
    tag: '娱乐',
  },
  {
    time: '4小时前',
    title: '年度热门综艺第二季正式官宣，原班人马回归引发期待',
    tag: '综艺',
  },
  {
    time: '6小时前',
    title: '知名网红品牌合作官宣，跨界联名引发行业关注',
    tag: '网红',
  },
  {
    time: '8小时前',
    title: '热播剧口碑持续走高，豆瓣评分突破8.5，创今年新高',
    tag: '影视',
  },
  {
    time: '10小时前',
    title: '音乐节官方发布完整演出时间表，多个舞台设置引期待',
    tag: '音乐',
  },
  {
    time: '12小时前',
    title: '社交媒体平台最新热搜话题：明星机场街拍造型引模仿热潮',
    tag: '时尚',
  },
  {
    time: '14小时前',
    title: '娱乐行业年度报告发布：直播与短视频成为主要增长引擎',
    tag: '产业',
  },
  {
    time: '16小时前',
    title: '多部新剧同日官宣定档，暑期档竞争进入白热化阶段',
    tag: '影视',
  },
];

export default function UpdatesSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">最新动态</h2>
            <p className="text-sm md:text-base text-foreground-500">
              实时追踪娱乐圈最新快讯，第一时间掌握吃瓜动态
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

            <div className="space-y-4">
              {updates.map((item, idx) => (
                <a
                  key={idx}
                  href="#updates"
                  onClick={(e) => handleNavClick(e, '#updates')}
                  className="flex items-start gap-5 group cursor-pointer"
                >
                  <div className={`relative z-10 flex-shrink-0 w-[38px] h-[38px] flex items-center justify-center rounded-full border-2 ${
                    idx < 3
                      ? 'border-primary-300 bg-primary-50 text-primary-600'
                      : 'border-background-300 bg-background-100 text-foreground-400'
                  } group-hover:border-primary-400 group-hover:bg-primary-50 group-hover:text-primary-600 transition-colors`}>
                    <span className="text-xs font-medium">{idx + 1}</span>
                  </div>
                  <div className="flex-1 min-w-0 pt-1.5">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <h3 className="text-sm md:text-base text-foreground-800 leading-relaxed group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}